import { render, staticRenderFns } from "./IconGekjb.vue?vue&type=template&id=2a702568"
import script from "./IconGekjb.vue?vue&type=script&lang=js"
export * from "./IconGekjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports